import {
	Breakpoints,
	Container,
	ContainerGutter,
	ContainerPadding,
	Layout,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { novedadesBackgroundColor } from '../../helpers/color-tokens';
import useNovedadesData from './hooks/use-novedades-data';
import { NovedadesCarousel } from './components/novedades-carousel';
import { PortalContext } from '../../context/portal-context';
import { NovedadesItem } from '@esportal/portal-service';
import { IContextNovedades } from './models/context-novedades';

const Background = styled.div`
	background: ${novedadesBackgroundColor};
`;

// provisional - para que no muestre novedades si recibe datos con el modelo antiguo
const isNewModel = (novedades: NovedadesItem[]): boolean => {
	return novedades.every((novedaded) => novedaded.card && novedaded.layer);
};

export const Novedades = (): React.ReactElement => {
	const sectionRef = useRef<HTMLElement>(null);
	const novedades = useNovedadesData('club'); // cambiar a posventa en posventa

	return (
		<>
			{novedades && isNewModel(novedades) && novedades.length > 0 && (
				<Background>
					<section ref={sectionRef}>
						<Container
							data-testid="novedades-container"
							padding={{
								top: ContainerPadding.dynamic0130,
								bottom: ContainerPadding.dynamic0130,
							}}
							wrap="always"
							gutter={ContainerGutter.dynamic0100}
						>
							<Layout
								data-testid="novedades-title-layout"
								appearance={{
									[Breakpoints.default]: [
										{ name: '.', columns: 1 },
										{ name: 'novedades-title', columns: 22 },
										{ name: '.', columns: 1 },
									],
								}}
							>
								<Container data-testid="novedades-section-title" wrap="always" gutter={ContainerGutter.dynamic0020}>
									<Text
										appearance={TokenTextAppearance.bigcopy200}
										color={TokenTextColor.primary}
										textAlign={TextAlignment.left}
										bold
									>
										Novedades
									</Text>
									<Text
										appearance={TokenTextAppearance.headline500}
										color={TokenTextColor.primary}
										textAlign={TextAlignment.left}
									>
										Entérate de <b>lo último</b>
									</Text>
								</Container>
							</Layout>

							<Layout
								data-testid="novedades-carousel-layout"
								appearance={{
									[Breakpoints.default]: [{ name: 'novedades-carousel', columns: 24 }],
								}}
							>
								<NovedadesCarousel
									novedades={novedades}
									// PortalContext has a broader shape; cast via unknown to satisfy TS safely
									context={PortalContext as unknown as React.Context<IContextNovedades>}
									key="second_div"
									data-testid="novedades-carousel"
								/>
							</Layout>
						</Container>
					</section>
				</Background>
			)}
		</>
	);
};
